module.exports = __webpack_public_path__ + "img/RosaKatz.e5e8c789.jpg";